import { Card } from "@/app/admin/_common/ui/card";
import { Badge } from "@/app/admin/_common/ui/badge";
import PerformerAvatar from "@/app/admin/_common/PerformerAvatar";
import CuoEmpty from "@/app/admin/_common/CuoEmpty";
import type { LocationPerformerSummary } from "@/app/_services/LocationService";
import { Mic2 } from "lucide-react";

export default function LocationPerformersList({
  performers,
}: {
  performers: LocationPerformerSummary[];
}) {
  return (
    <Card className="flex flex-col rounded-md p-4 shadow-none">
      <div className="mb-3 text-[13.5px] font-semibold text-foreground">Performers</div>
      {performers.length === 0 ? (
        <CuoEmpty icon={Mic2} text="No performers yet" />
      ) : (
        <div className="flex max-h-[150px] flex-col gap-2.5 overflow-y-auto pr-1">
          {performers.map((performer) => (
            <div key={performer.performer_id} className="flex items-center gap-2.5">
              <PerformerAvatar
                src={performer.img_url}
                firstName={performer.first_name}
                lastName={performer.last_name}
                style={{ height: 28, width: 28 }}
              />
              <div className="min-w-0 flex-1 truncate text-[13px] text-foreground">
                {performer.first_name} {performer.last_name}
              </div>
              <Badge variant="outline" className="flex-none border-border text-[11px] font-normal text-muted-foreground">
                {performer.times}×
              </Badge>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}
